<script context="module">
  import { router } from 'tinro'
  import { currentPage, loginToken, userDetails } from '../components/DataStore'
  import { getCookie, eraseCookie } from './CookieUtils.svelte'
  import { mixpanel } from './analytics.js'

  import { API_BASE_URL } from '../config.js'

  // set per environment in the .env files (VITE_API_BASE_URL, see .env.example)
  export const BASE_URL = API_BASE_URL

  // moved to src/api/session.js; re-exported for the existing imports
  export { checkJwtTokenValidity } from '../api/session.js'
  import { checkJwtTokenValidity } from '../api/session.js'

  export async function postData(
    url = '',
    data = {},
    logoutParam = true,
    fullUrl = false
  ) {
    if (!fullUrl) {
      url = BASE_URL + url
    }
    //let token = sessionStorage.getItem("jwtToken") || "";
    let token = getCookie('jwtToken') || ''

    const response = await fetch(url, {
      method: 'POST', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, *cors, same-origin
      cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      credentials: 'same-origin', // include, *same-origin, omit
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      redirect: 'follow', // manual, *follow, error
      referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      body: JSON.stringify(data), // body data type must match "Content-Type" header
    })

    if (response.status >= 400 && response.status < 600) {
      if (logoutParam) {
        handleServerError(response.status)
      } else {
        let errorMessage = 'Bad response from server status:' + response.status
        let body
        try {
          body = await response.json()
          errorMessage = body?.errorCode
          console.log(555, errorMessage)
        } catch (error2) {
          errorMessage = 'Bad response from server status:' + response.status
        }
        if (!errorMessage) {
          errorMessage = 'Bad response from server status:' + response.status
        }
        const error = new Error(errorMessage)
        error.status = response.status
        // the whole answer, for callers that show more than the code (e.g. a reference to give support)
        error.body = body
        throw error
      }
    }

    return response.json() // parses JSON response into native JavaScript objects
  }

  export async function putData(url = '', data = {}, logoutParam = true) {
    url = BASE_URL + url
    //let token = sessionStorage.getItem("jwtToken");
    let token = getCookie('jwtToken')

    const response = await fetch(url, {
      method: 'PUT', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, *cors, same-origin
      cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      credentials: 'same-origin', // include, *same-origin, omit
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
      redirect: 'follow', // manual, *follow, error
      referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      body: JSON.stringify(data), // body data type must match "Content-Type" header
    })

    if (response.status >= 400 && response.status < 600) {
      if (logoutParam) {
        handleServerError(response.status)
      } else {
        let errorMessage = 'Bad response from server status:' + response.status
        try {
          errorMessage = (await response.json()).errorCode
          console.log(555, errorMessage)
        } catch (error2) {
          errorMessage = 'Bad response from server status:' + response.status
        }
        if (!errorMessage) {
          errorMessage = 'Bad response from server status:' + response.status
        }
        throw new Error(errorMessage)
      }
    }

    return response.json() // parses JSON response into native JavaScript objects
  }

  export async function patchData(url = '', data = {}, readJson = true) {
    url = BASE_URL + url
    //let token = sessionStorage.getItem("jwtToken");
    let token = getCookie('jwtToken') || ''

    const response = await fetch(url, {
      method: 'PATCH', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, *cors, same-origin
      cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      credentials: 'same-origin', // include, *same-origin, omit
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
      redirect: 'follow', // manual, *follow, error
      referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      body: JSON.stringify(data), // body data type must match "Content-Type" header
    })

    if (response.status >= 400 && response.status < 600) {
      handleServerError(response.status)
    }
    if (readJson){
      return response.json() // parses JSON response into native JavaScript objects
    } else{
      return response.text()
    }
  }

  export async function getData(url = '', fullUrl = false, logoutParam = true) {
    if (!fullUrl) {
      url = BASE_URL + url
    }

    //let token = sessionStorage.getItem("jwtToken") || "";
    let token = getCookie('jwtToken') || ''

    let headerPayload = {
      'Content-Type': 'application/json',
    }
    if (token != null) {
      if (!checkJwtTokenValidity(token)) {
        logout()
        throw new Error('Invalid token')
      }
      headerPayload = {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      }
    }

    const response = await fetch(url, {
      method: 'GET', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, *cors, same-origin
      cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      credentials: 'same-origin', // include, *same-origin, omit
      headers: headerPayload,
      redirect: 'follow', // manual, *follow, error
      referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    })

    if (response.status >= 400 && response.status < 600) {
      if (logoutParam) {
        handleServerError(response.status)
      } else {
        throw new Error('Bad response from server status:' + response.status)
      }
    }

    return response.json() // parses JSON response into native JavaScript objects
  }

  export async function deleteData(url = '') {
    url = BASE_URL + url
    //let token = sessionStorage.getItem("jwtToken");
    let token = getCookie('jwtToken')

    const response = await fetch(url, {
      method: 'DELETE', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, *cors, same-origin
      cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      credentials: 'same-origin', // include, *same-origin, omit
      headers: {
        'Content-Type': 'application/json',
        // 'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: 'Bearer ' + token,
      },
      redirect: 'follow', // manual, *follow, error
      referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    })

    if (response.status >= 400 && response.status < 600) {
      handleServerError(response.status)
    }

    return response // parses JSON response into native JavaScript objects
  }

  export async function getDataOutside(url = '') {
    const response = await fetch(url, {
      method: 'GET', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, *cors, same-origin
      cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      credentials: 'same-origin', // include, *same-origin, omit
      redirect: 'follow', // manual, *follow, error
      referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    })

    if (response.status >= 400 && response.status < 600) {
      throw new Error('Bad response from server status:' + response.status)
    }

    return response.json() // parses JSON response into native JavaScript objects
  }

  export async function postJsonFileGetText(
    url = '',
    headersValue = {},
    params = {},
    data = {}
  ) {
    var urlValue = new URL(url)
    urlValue.search = new URLSearchParams(params).toString()

    // Default options are marked with *
    const response = await fetch(urlValue, {
      method: 'POST', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, *cors, same-origin
      cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      credentials: 'same-origin', // include, *same-origin, omit
      redirect: 'follow', // manual, *follow, error
      referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      headers: headersValue,
      body: JSON.stringify(data), // body data type must match "Content-Type" header
    })

    return response.text() // parses JSON response into native JavaScript objects
  }

  export async function postDataRawResponse(
    url = '',
    data = {},
    hanldeError = true
  ) {
    url = BASE_URL + url
    //let token = sessionStorage.getItem("jwtToken") || "";
    let token = getCookie('jwtToken')

    let headers = {
      'Content-Type': 'application/json',
    }
    if (token) {
      headers['Authorization'] = 'Bearer ' + token
    }

    const response = await fetch(url, {
      method: 'POST', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, *cors, same-origin
      cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      credentials: 'same-origin', // include, *same-origin, omit
      headers: headers,
      redirect: 'follow', // manual, *follow, error
      referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      body: JSON.stringify(data), // body data type must match "Content-Type" header
    })

    if (hanldeError && response.status >= 400 && response.status < 600) {
      handleServerError(response.status)
    } else if (response.status >= 400 && response.status < 600) {
      throw new Error('Bad response from server')
    }

    return response // parses JSON response into native JavaScript objects
  }

  export async function postFile(url = '', params = {}, data = '') {
    let urlValue = new URL(url)
    urlValue.search = new URLSearchParams(params).toString()

    // Default options are marked with *
    const response = await fetch(urlValue, {
      method: 'POST', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, *cors, same-origin
      cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      credentials: 'same-origin', // include, *same-origin, omit
      headers: {
        'Content-Type': 'image/jpg',
      },
      redirect: 'follow', // manual, *follow, error
      referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      body: data, // body data type must match "Content-Type" header
    })

    return response.json() // parses JSON response into native JavaScript objects
  }

  function handleServerError(status) {
    if (status === 401 || status === 406) {
      logout()
    }

    throw new Error('Bad response from server')
  }

  export function logout() {
    sessionStorage.removeItem('jwtToken')
    mixpanel.reset()
    eraseCookie('jwtToken')
    window.location.reload()
    loginToken.update((x) => undefined)
    userDetails.update((x) => undefined)
    currentPage.update((x) => 'login')
    //router.goto("/login");
  }
</script>
